import React from 'react';
import classes from './style.module.css'
import { GREYHOUND_TABLE_ALL_STATIC, GREYHOUND_TABLE_COLUMNS_STATIC } from '../../../constants/Constants'
import OddResultCell from './OddResultCell'
import WinDetailCell from './WinDetailCell'
import StarRatings from 'react-star-ratings';

const roundOff = (reating) => {
    return Math.floor(reating * 100) / 100;
}
const League = (props) => {
    const rowIndex = props.index + 1;
    const id = props.item.time;
    const type = props.type;
    const columnList = props.finalColumns;

    const cells = columnList.map(column => {
        let cell = null;
        const cellKey = id + "_" + column.id
        //console.log(props.item.raceId)
        switch (column.id) {
            case GREYHOUND_TABLE_COLUMNS_STATIC.ROW_NUM.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{rowIndex}</th>
                break;
            case GREYHOUND_TABLE_ALL_STATIC.TRACK.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{props.item.trackName}
                    {type === 'ALL' ? ' R' + props.item.raceId : ''}
                </th>
                break;
            case GREYHOUND_TABLE_ALL_STATIC.TIME.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{props.item.raceTime}</th>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.TRAP.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.trap}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.DOG_NAME.id:
                cell = (<td style={{ width: "315px" }} key={cellKey} className={classes.LeagueTdTh}>{props.item.runner}
                    &nbsp; &nbsp; &nbsp;
                    <div style={{ float: "right" }}>
                        <StarRatings
                            starDimension="20px"
                            starSpacing="0"
                            rating={props.item.starRating}
                            starRatedColor="blue"
                            numberOfStars={5}
                            name='rating'
                        />
                    </div>
                </td>)
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.GRADE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.grade}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.DISTANCE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.distance}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.SEX.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.sex}</td>
                break;

            case GREYHOUND_TABLE_COLUMNS_STATIC.FORM.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.last5Run}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.WIN_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.winPercent)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.TRAP_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.trapPercent)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.DAYS_SINCE_LAST_RUN.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.daysSinceLastRun}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.TRAP_CUM_TRAINER.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.trapCunTrainerPercent)}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.TIME_FORM.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.timeFormRating}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.SPEED_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.averageSpeedPercent)}</td>
                break;

            case GREYHOUND_TABLE_COLUMNS_STATIC.POTENTIAL_LAY.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.potentialLay ? 'Yes' :'No' }</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.ODD_DETAILS.id:
                let part = props.item;
                console.log(JSON.stringify(part))
                let details = "-,-"
                if (part.bfSelectionId && part.bfMarketId) {
                    details = <OddResultCell date={props.date} type={type} oddChangeCallback={props.oddChangeCallback} marketId={part.bfMarketId} selectionId={part.bfSelectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{details}</td>
                break;
            case GREYHOUND_TABLE_COLUMNS_STATIC.WIN_DETAILS.id:
                let currentItem = props.item;
                let winnerDetails = "-"
                if (currentItem.bfSelectionId && currentItem.bfMarketId) {
                    winnerDetails = <WinDetailCell type={type}  marketId={currentItem.bfMarketId}
                        date={props.date} time={props.item.raceTime}
                        selectionId={currentItem.bfSelectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{winnerDetails}</td>
                break;
            default:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>-</td>
        }
        return cell;
    })

    return (
        <tr className={classes.League}>
            {cells}
        </tr>
    )
}

export default League;